<script setup>
import { ref, onMounted, onUnmounted } from 'vue';

const CHECK_INTERVAL = 60000;
const buildVersion = ref(null);
const newVersionAvailable = ref(false);
let checkTimer = null;

async function fetchBuildVersion() {
  try {
    const response = await fetch(`/build-version.txt?t=${Date.now()}`, {
      cache: 'no-store',
    });
    if (response.ok) {
      return (await response.text()).trim();
    }
  } catch {
    // silently ignore
  }
  return null;
}

async function checkForUpdate() {
  const currentVersion = await fetchBuildVersion();
  if (!currentVersion) return;

  if (!buildVersion.value) {
    buildVersion.value = currentVersion;
    return;
  }

  if (currentVersion !== buildVersion.value) {
    newVersionAvailable.value = true;
  }
}

function reloadApp() {
  if ('caches' in window) {
    caches
      .keys()
      .then(names => Promise.all(names.map(name => caches.delete(name))));
  }
  window.location.reload(true);
}

onMounted(() => {
  checkForUpdate();
  checkTimer = setInterval(checkForUpdate, CHECK_INTERVAL);
});

onUnmounted(() => {
  if (checkTimer) clearInterval(checkTimer);
});
</script>

<!-- eslint-disable-next-line vue/no-root-v-if -->
<template>
  <div
    v-if="newVersionAvailable"
    class="flex items-center justify-center gap-2 px-4 py-2 text-sm font-medium text-white bg-woot-600 cursor-pointer hover:bg-woot-700 transition-colors"
    @click="reloadApp"
  >
    <span class="i-lucide-refresh-cw h-4 w-4 animate-spin" />
    {{ $t('GENERAL_SETTINGS.BUILD_UPDATE_AVAILABLE') }}
  </div>
</template>
